// extracted by mini-css-extract-plugin
export var childrenContainer = "_3z-0";
export var virtualScrollArea = "_3z-1";